export default "__VITE_ASSET__DQlRG7pP__"